module.exports = __webpack_public_path__ + "img/full7-min.fad7c044.png";